export const getConfig = () => {
  const clientId = process.env.AUTH0_CLIENT_ID;
  const domain = process.env.AUTH0_DOMAIN;
  const audience = process.env.AUTH0_AUDIENCE;
  return { clientId, domain, audience };
};
